// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-n_fY","advertDetailHeaderLocation__value":"c-n_fZ"};